<h3>Conversion Detail</h3>
<p>
  Id: {{conversionInfo.id}}
</p>
<p>
  Date: {{conversionInfo.runAtUtc | date: 'dd.MM.yyyy HH:mm'}}
</p>
<p>
  Duration: {{conversionInfo.durationInMs}} ms
</p>
<p>
  Filename: {{conversionInfo.fileName}}
</p>
@if (conversionInfo.clientName) {
  <p>
    Client: {{conversionInfo.clientName}}
  </p>
}
<p>
  Source Type: {{conversionInfo.sourceType}}
</p>
@if (conversionInfo.detailedSourceType) {
  <p>
    Detailed Source Type: {{conversionInfo.detailedSourceType}}
  </p>
}
<p>
  Source Phase: {{conversionInfo.sourceExchangePhase}}
</p>
<p>
  Destination Type: {{conversionInfo.destinationType}}
</p>
@if (conversionInfo.sourceGaebProgName) {
  <p>
    Source Prog Name: {{conversionInfo.sourceGaebProgName}}
  </p>
}
@if (conversionInfo.sourceGaebProgSystem) {
  <p>
    Source Prog System: {{conversionInfo.sourceGaebProgSystem}}
  </p>
}
@if (conversionOptions()) {
  <p>
    Conversion Options:
  </p>
}
@if (conversionOptions()) {
  <pre>{{conversionOptions() | json}}</pre>
}
@if (conversionInfo.fileIsPersistedToStorage) {
  <button mat-button (click)="downloadFile()">Download File</button>
}
